import { render, staticRenderFns } from "./step_2.vue?vue&type=template&id=74a9c8cc"
import script from "./step_2.vue?vue&type=script&lang=js"
export * from "./step_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports